import types from 'actions/types'
import {combineReducers} from 'redux'
import Immutable from 'seamless-immutable'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const listBuilderContactsPivotTableKey = 'contactsContext.listBuilder.contacts'

const newContactList = {}

const selected = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_NEW_BUILDER_LIST: return Immutable({ ...newContactList, ...action.list })
    case types.CONTACT_LISTS_LOAD_LIST_SUCCESS: return Immutable(action.data)
    case types.CONTACT_LISTS_UPDATE_BUILDER_LIST: return Immutable(action.list)
    case types.CONTACT_LIST_BUILDER_ADD_FILTER: {
      if (state === null) return state
      return {
        ...state,
        filters: [
          ...state.filters || [],
          action.filter,
        ],
      }
    }
    case types.CONTACT_LIST_BUILDER_UPDATE_FILTER: {
      if (state === null) return state
      return {
        ...state,
        filters: (state.filters || []).map(f => f.id === action.filter.id ? action.filter : f),
      }
    }
    case types.CONTACT_LIST_BUILDER_UPDATE_FILTERS: {
      if (state === null) return state
      return {
        ...state,
        filters: (state.filters || []).map(filter => {
          const updated = action.filters.find(f => f.key === filter.key)
          if (updated) return updated
          return filter
        }),
      }
    }
    case types.CONTACT_LIST_BUILDER_REMOVE_FILTER: {
      if (state === null) return state
      return {
        ...state,
        filters: (state.filters || []).filter(f => f.id !== action.filterId),
      }
    }
    case types.CONTACT_LISTS_BUILDER_REQUERY_SUCCESS:
      if (state === null) return state
      return Immutable({
        ...state,
        summary: action.data,
      })
    default: return state
  }
}

const total = (state = Immutable(null), action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_GET_TOTAL_SUCCESS: return action.total
    default: return state
  }
}

const loading = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_LOAD_LIST_ATTEMPT: return Immutable(true)
    case types.CONTACT_LISTS_NEW_LIST:
    case types.CONTACT_LISTS_LOAD_LIST_SUCCESS:
    case types.CONTACT_LISTS_LOAD_LIST_FAILURE: return Immutable(false)
    default: return state
  }
}

const querying = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_BUILDER_REQUERY_ATTEMPT: return Immutable(true)
    case types.CONTACT_LISTS_BUILDER_REQUERY_SUCCESS:
    case types.CONTACT_LISTS_BUILDER_REQUERY_FAILURE: return Immutable(false)
    default: return state
  }
}

const saving = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_ADD_LIST_ATTEMPT:
    case types.CONTACT_LISTS_UPDATE_LIST_ATTEMPT: return Immutable(true)
    case types.CONTACT_LISTS_ADD_LIST_SUCCESS:
    case types.CONTACT_LISTS_ADD_LIST_FAILURE:
    case types.CONTACT_LISTS_UPDATE_LIST_SUCCESS:
    case types.CONTACT_LISTS_UPDATE_LIST_FAILURE: return Immutable(false)
    default: return state
  }
}

const previewValid = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_LOAD_LIST_ATTEMPT:
    case types.CONTACT_LISTS_NEW_BUILDER_LIST:
    case types.CONTACT_LISTS_BUILDER_REQUERY_ATTEMPT: return Immutable(false)
    case types.PIVOT_TABLE_REQUEST_DATA:
      if (action.key === listBuilderContactsPivotTableKey) return Immutable(true)
      return state
    default: return state
  }
}

const filterValues = (state = Immutable({}), action) => {
  switch (action.type) {
    case types.CONTACT_LISTS_LOAD_LIST_ATTEMPT:
    case types.CONTACT_LISTS_NEW_BUILDER_LIST: return Immutable({})
    case types.CONTACT_LISTS_LOAD_FILTER_VALUES_SUCCESS: {
      return Immutable({
        ...state,
        [action.key]: action.data,
      })
    }

    default: return state
  }
}

export default combineReducers({
  selected,
  loading,
  querying,
  saving,
  filterValues,
  previewValid,
  total,
  contacts: createPivotTableReducer({key: listBuilderContactsPivotTableKey, defaultSortColumn: 'forename', defaultSortDirection: 'asc', pageSize: 50}),
})
